import getPermissionsApi from '@/api/get/config/get-permissions';
import getUserRoleApi from '@/api/get/user-management/get-user-role';
import Card from '@/components/card/card-component';
import SubmitCard from '@/components/card/submit-card-component';
import { Col, Row } from '@/components/grid/grid-component';
import PageWrapper from '@/components/page-wrapper/page-wrapper-component';
import Pill from '@/components/pill/pill-component';
import { useQuery } from '@/hooks/use-api';
import { BodyText, SmallTitle } from '@/utils/global-fonts';
import { toSentenceCase } from '@/utils/utils';
import { useNavigate, useParams } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import Styled from './user-roles-view-style';

/**
 * User role view component
 * @returns {JSX.Element}
 */
const UserRolesView = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: userRole, loading, error } = useQuery(getUserRoleApi, id);
  const { data: permissions } = useQuery(getPermissionsApi, id);
  let resultArray = [];
  permissions?.forEach((item2) => {
    userRole?.permissions?.forEach((item1) => {
      if (item1.feature_id === item2.feature_id) {
        resultArray.push({ ...item2, ...item1 });
      }
    });
  });

  resultArray = resultArray.map((obj) => {
    const { featureId, feature, ...newObj } = obj;
    return {
      ...newObj,
      name: feature.name,
    };
  });

  const defaultUserRole = {
    ...userRole,
    permissions: resultArray,
  };

  delete defaultUserRole.permissions.feature_id;
  delete defaultUserRole.permissions.feature;

  const keyMapping = {
    create: 'Create',
    read: 'Read',
    update: 'Update',
    delete: 'Delete',
  };

  if (loading) {
    <Styled.Div>
      <ClipLoader size={100} />
    </Styled.Div>;
  }

  if (error) {
    <div>loading</div>;
  }

  return (
    <PageWrapper>
      <Card padding="16px 18px 10px 24px">
        <Row>
          <Col xs={6}>
            <Styled.DivStyle>
              <SmallTitle>USER ROLE NAME</SmallTitle>
              <BodyText>{toSentenceCase(defaultUserRole.name)}</BodyText>
            </Styled.DivStyle>
          </Col>
          <Col xs={6}>
            <Styled.DivStyle>
              <SmallTitle>USER ROLE DESCRIPTION</SmallTitle>
              <BodyText>{toSentenceCase(defaultUserRole.description)}</BodyText>
            </Styled.DivStyle>
          </Col>
          <Col xs={12}>
            <Row>
              <Col xs={12}>
                <SmallTitle>PERMISSIONS</SmallTitle>
                {defaultUserRole.permissions.map((permission) => {
                  const shouldRenderTitle =
                    permission.read ||
                    permission.create ||
                    permission.update ||
                    permission.delete;

                  const validKeys = ['create', 'read', 'update', 'delete'];

                  let hasValidKey = false;

                  Object.keys(permission).forEach((key) => {
                    if (validKeys.includes(key)) {
                      hasValidKey = true;
                    }
                  });

                  if (!hasValidKey) {
                    return null;
                  }
                  return (
                    <Row direction="row" key={permission.id}>
                      {shouldRenderTitle && (
                        <Col xs={12}>
                          <SmallTitle data-cy={`h4${permission.feature_id}`}>
                            {permission.name}
                          </SmallTitle>
                        </Col>
                      )}
                      <Col xs={12} md={12} lg={6}>
                        <Row $margin="0">
                          {Object.keys(permission).map((key) => {
                            if (validKeys.includes(key) && permission[key]) {
                              return (
                                <Col key={key} xs={3} md={2}>
                                  <Pill type={keyMapping[key]} />
                                </Col>
                              );
                            }
                            return null;
                          })}
                        </Row>
                      </Col>
                    </Row>
                  );
                })}
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
      <SubmitCard
        padding="0"
        primaryButtonTitle="Edit"
        primaryButtonType="submit"
        primaryPermission={['userRole.update']}
        primaryButtonDisabled={false}
        primaryButtonWidth="112px"
        secondaryButtonType="button"
        secondaryButtonDisabled={false}
        isLoading={loading}
        secondaryButtonWidth="112px"
        secondaryPermission={['userRole.delete']}
        submitClick={() => {
          navigate(`/app/user-management/user-roles/edit/${id}`);
        }}
        submitClickSecondary={() => {
          navigate(-1);
        }}
        secondaryButtonTitle="Cancel"
      />
    </PageWrapper>
  );
};

UserRolesView.defaultProps = {};

UserRolesView.propTypes = {};

export default UserRolesView;
